import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublishmentsData } from "../../features/publishments/publishment";
import PublishmentCard from "./PublishmentCard";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Autoplay, Navigation } from "swiper/modules";
import ArrowRight, { ArrowLeft } from "../../Icons/Icon";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import getDirctionLang from "../../Actions/getDirctionLang";
import { SeeMore } from "../../Buttons/Buttons";

function Publishment() {
  const dispatch = useDispatch();
  const perPage = 6;
  const { publishments } = useSelector((state) => state.publishments);
  const { i18n, t } = useTranslation()
  useEffect(() => {
    dispatch(fetchPublishmentsData({perPage}));
  }, [dispatch, i18n.language]);
  const isRtl = getDirctionLang();
  return (
    <div className='mx-auto w-full lg:w-10/12 xl:w-10/12 2xl:w-9/12 md:p-10 my-3 mt-5'>
      <div className="flex flex-col gap-4">
        <p className="font-bold text-center capitalize my-3 text-4xl">
          {t("ourPublications")}
        </p>
      </div>

      {publishments?.length === 0 ? (
        <div className="flex flex-col gap-4 items-center justify-center">
          <p className="font-bold text-center capitalize my-3 text-4xl">

          </p>
        </div>
      ) : (
        <Swiper
          key={i18n.language}

          slidesPerView={1}
          spaceBetween={30}
          grabCursor={true}
          centeredSlides={true}
          //   grabCursor={true}
          breakpoints={{
            640: { slidesPerView: 3, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 40 },
            1024: { slidesPerView: 3, spaceBetween: 50 },
          }}
          modules={[Navigation, Autoplay]}
          loop={publishments?.length >= 3} // Only enable loop if enough items
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          dir={isRtl ? "rtl" : "ltr"}
          navigation={{
            nextEl: isRtl ? ".prev" : ".next",
            prevEl: isRtl ? ".next" : ".prev",
            clickable: true,
          }}
          className="mySwiper"
        >
          {publishments?.map((publishment) => (
            <SwiperSlide key={publishment.id}>
              <Link to={`/publication/${publishment.id}`}>
                <PublishmentCard publishment={publishment} />
              </Link>
            </SwiperSlide>
          ))}
          <ArrowRight />

          <ArrowLeft />
        </Swiper>
      )}
      <div className="flex justify-center mt-4">

        <SeeMore link={"/publication"} />
      </div>
    </div>
  );
}

export default Publishment;
